import clsx from 'clsx'

import { MessageType } from '../machines/emailReport.machine'

export interface StatusMessageProps {
  className?: string
  type?: MessageType
  children?: string
  retry?: () => void
}

export function StatusMessage({ className, type, children, retry }: StatusMessageProps) {
  if (!children) {
    return null
  }

  return (
    <p data-message={type} className={clsx('text-xs tracking-wide mt-2 mx-0.5', className)}>
      {children}{' '}
      {retry && (
        <button className="text-xs text-blue-500 hover:text-blue-700 underline hover:no-underline" onClick={retry}>
          Retry
        </button>
      )}
    </p>
  )
}
